import { sourceAnalysisLabel } from '@/common/app/modules/media/mediaAction'
import { dateTimeStr } from '@/common/form/date'
import { ActionDetail } from '@/common/model/media/mediaAction'

import Badge, { BadgeType } from '@/components/view/atoms/badge/Badge'
import Text from '@/components/view/atoms/text/Text'
import ItemAlign from '@/components/view/layouts/item/ItemAlign'
import PriorityBar from '@/components/view/molecules/bar/PriorityBar'

// 分類タグ＋値の1行（実行日時・アクションIDなど）
const LabeledValue = ({ label, value }: { label: string; value: string }) => (
  <ItemAlign gapX={4} align='baseline'>
    <Badge size={10} badgeType={BadgeType.SQUARE_TERTIARY}>
      {label}
    </Badge>
    <Text size={14}>{value}</Text>
  </ItemAlign>
)

interface Props {
  detail: ActionDetail
}

// AI記事作成画面で、遷移元の推奨アクション情報を表示するバナー（アクションとのひも付きを明示）
const MediaActionSourceBanner = ({ detail }: Props) => {
  const a = detail.action

  return (
    <div className='mb-4 flex flex-col gap-2'>
      <div className='flex flex-wrap items-center gap-4'>
        {detail.source_summary && (
          <Badge size={12} badgeType={BadgeType.SQUARE_PRIMARY}>
            {sourceAnalysisLabel(detail.source_summary.analysis_type)}
          </Badge>
        )}
        {detail.source_summary?.created_at && (
          <LabeledValue label='実行日時' value={dateTimeStr(detail.source_summary.created_at)} />
        )}
        <LabeledValue label='アクションID' value={`A-${a.id}`} />
      </div>
      <PriorityBar
        priority={a.priority}
        title={a.title}
        contentText={a.description || '（説明なし）'}
        subContent={
          (a.target_keywords ?? []).length > 0 && (
            <div className='flex w-70 flex-col gap-1'>
              <Badge size={10} badgeType={BadgeType.SQUARE_TERTIARY}>
                対象キーワード
              </Badge>
              <ItemAlign gapX={4} gapY={4} align='center' direction='horizon'>
                {a.target_keywords.map((kw, ki) => (
                  <Badge key={ki} size={10} badgeType={BadgeType.KEYWORD}>
                    {kw}
                  </Badge>
                ))}
              </ItemAlign>
            </div>
          )
        }
      />
    </div>
  )
}

export default MediaActionSourceBanner
